import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import PropTypes from 'prop-types';

const ClassTableComp = ({pageState, pickerState}) => {
    const [classData, setClassData] = useState(pageState.classes);
    const [currentClass, setCurrentClass] = useState(pageState.classID);

    const toggleSelected = (userID) =>{
        let nextState = [...classData];
        nextState.map( e => e.isSelected = false);
        nextState.find( e => e.ClassID === userID).isSelected = true;
        setClassData(nextState);
        setCurrentClass(userID);
    };    

    const changeClassClick=()=>{
        pageState.setClassID(currentClass);
        pageState.deleteThis('getAllTimeMarksForClassByDateRange');
        pageState.deleteThis('getAllClassAssignments');
        pickerState.setShowPicker(false);
    };

    return (<>          
        <div style={{overflowY:'scroll', overflowX : 'hidden',height:'250px', padding:'10px', border: '1px solid #cfcfcf'}}>
            {classData.map((classRec, i) => 
                <ClassRow key={i} data={classRec} toggleSelected={toggleSelected}/>
            )}
        </div>
        <br/>
        <Button onClick={changeClassClick} variant='success'> Select Class </Button>
    </>
    );
};

ClassTableComp.propTypes = {
    data: PropTypes.array,
    importState: PropTypes.object
};

const ClassRow = (props) => {
    const {Classname, ClassID, isSelected} = props.data;

    const rowStyle = {
        backgroundColor: (isSelected ? 'lightblue' : 'white'), 
        margin: '2px', 
        cursor: 'pointer',
        borderBottom: '1px solid #cfcfcf'
    };
    
    return (
        <>
            <Row style={rowStyle} onClick={()=>props.toggleSelected(ClassID)}>
                <Col style={{textAlign: 'left'}} xs='6'> {Classname} </Col>
            </Row>
        </>
    );
};

export default ClassTableComp;